var RangedAttributeValidationCode;
(function (RangedAttributeValidationCode) {
    RangedAttributeValidationCode["EMPTY_INPUT"] = "emptyInput";
    RangedAttributeValidationCode["NOT_A_NUMBER"] = "notANumber";
    RangedAttributeValidationCode["NOT_IN_RANGE"] = "notInRange";
    RangedAttributeValidationCode["UNSUPPORTED_PRECISION"] = "unsupportedPrecision";
    RangedAttributeValidationCode["UNKNOWN_ERROR"] = "unknownError";
    RangedAttributeValidationCode["SUCCESS"] = "success";
})(RangedAttributeValidationCode || (RangedAttributeValidationCode = {}));

export { RangedAttributeValidationCode };
//# sourceMappingURL=ranged-attribute-validation.mjs.map
